<template>
  <div class="main-content" ref="mainContent">
<!--    <div class="main-content-p1">-->
<!--      <p>强悍的强</p>-->
<!--    </div>-->
<!--    <div class="text-content"-->
<!--         style="display: flex;justify-content: center; text-indent: 2em;font-size: 1.2em;flex-direction: column;align-items: center;">-->
<!--      <p class="animate-item">-->
<!--        我们迄今最强的多层裁床S系列来了。搭载全新的EVOLUTION操作软件，内含动态裁剪（边走边裁）和刀智能纠偏（CIC）功能，带来裁剪质量和效率的颠覆性提升。 6000rpm振动箱，高速稳定。高强度钢结构床身，经历100万次真空吸附测试， 坚不可摧。GALAXY Mars55真空风机，45kw超高功率，带来无以伦比的真空吸附。 隐藏式消音器，收料区开阔无遮挡。一款强悍又独树一帜的裁床由此诞生。 这个S系列裁床，就是个强悍的猛兽。-->
<!--      </p>-->
<!--      <p class="animate-item price">RMB 530,000 起</p>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  name: 'DisplayContent',
  mounted() {
    this.$nextTick(() => {
      // // 获取需要动画的元素
      // const container = this.$refs.mainContent;
      // const titleElement = document.querySelector('.main-content-p1');
      // const textElements = document.querySelectorAll('.animate-item');
      //
      // // 存储所有动画元素以便统一管理
      // const allElements = [titleElement, ...Array.from(textElements)];
      //
      // // 初始化元素状态
      // this.$gsap.set(titleElement, {
      //   y: 150,
      //   opacity: 0,
      //   transformPerspective: 1000,
      //   rotationX: 5
      // });
      //
      // this.$gsap.set(textElements, {
      //   y: 80,
      //   opacity: 0,
      //   transformPerspective: 1000,
      //   rotationX: 3
      // });
      //
      // // 创建主时间线，支持双向平滑动画
      // const masterTimeline = this.$gsap.timeline({
      //   scrollTrigger: {
      //     trigger: container,
      //     start: 'top 85%',      // 进入视口的触发点
      //     end: 'bottom 15%',     // 离开视口的触发点
      //     markers: false,
      //     // 滚动时的动画行为：进入播放、离开反向播放
      //     toggleActions: 'play reverse play none',
      //     scrub: 2,
      //     invalidateOnRefresh: true // 窗口大小变化时重新计算
      //   }
      // });
      //
      // // 入场动画 - 从下往上出现
      // masterTimeline.to(titleElement, {
      //   y: 0,
      //   opacity: 1,
      //   rotationX: 0,
      //   duration: 1.5,
      //   ease: 'power2.out'
      // }, 0);
      //
      // // 文本内容依次入场
      // textElements.forEach((el, index) => {
      //   masterTimeline.to(el, {
      //     y: 0,
      //     opacity: 1,
      //     rotationX: 0,
      //     duration: 1.5,
      //     ease: 'power2.out'
      //   }, 0.4 + index * 0.2);
      // });
      //
      // // 添加一个保持可见的阶段
      // masterTimeline.to({}, {duration: 0.5});
      //
      // // 离场动画 - 向上滚动离开时向上消失
      // masterTimeline.to(titleElement, {
      //   y: -100,
      //   opacity: 0,
      //   rotationX: -3,
      //   duration: 1.5,
      //   ease: 'power2.in'
      // });
      //
      //
      // masterTimeline.to(textElements, {
      //   y: -200,
      //   // opacity: 0,
      //   rotationX: -2,
      //   duration: 0.9,
      //   ease: 'power2.out'
      // }); // 与入场顺序相反的离场顺序


      // 文本内容依次离场
      // textElements.forEach((el, index) => {
      //   masterTimeline.to(el, {
      //     y: -200,
      //     // opacity: 0,
      //     rotationX: -2,
      //     duration: 0.9,
      //     ease: 'power2.out'
      //   }, `<${index * 0.15}`); // 与入场顺序相反的离场顺序
      // });

      // 确保所有元素在动画外都有正确的初始状态
      // this.$gsap.set(allElements, {
      //   willChange: 'transform, opacity',
      //   backfaceVisibility: 'hidden'
      // });
    });
  }
}
</script>
<style scoped lang="less">
.main-content {
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 60vh;
  padding: 2rem 5%;
  box-sizing: border-box;
  margin-top: 200px;
}

.main-content-p1 {
  width: 100%;
  font-size: var(--font-size-xl2);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
}

.text-content {
  max-width: 1400px;
  width: 100%;
  line-height: 1.8;
  font-size: var(--font-size-lg2);
}

.animate-item {
  font-size: var(--font-size-lg2);
  text-align: left;
  margin: 1rem 0;
}

.price {
  font-size: var(--font-size-lg2);
  margin-top: 2rem;
  color: #333;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .main-content-p1 {
    font-size: 1.3em;
  }

  .text-content {
    font-size: 1.3em;
  }
}
</style>
